import "./ItemsSoldReport.scss";

import React from "react";
import usesFeatures from "usesFeatures";

import Table from "Table";
import Header from "Header";
import Paginate from "Paginate";
import BaseReport from "VenueAdmin/shared/BaseReport";
import ReportFilters from "VenueAdmin/shared/ReportFilters";

class ItemsSoldReport extends BaseReport {
  getBaseEndpoint() {
    return "venue_admin/items_sold";
  }

  getSearchEndpoint() {
    return "venue_admin/items_sold/search_products";
  }

  getDownloadFilename() {
    return `Items Sold Report - ${new Date().toISOString().split('T')[0]}.csv`;
  }

  getItemIdsParamName() {
    return "product_ids";
  }

  getItemsDataKey() {
    return "products";
  }

  itemFormatters = () => ({
    storeName: (item) => item.storeName,
    productName: (item) => (
      <a href={`/products/${item.productId}`} target="_blank" rel="noopener noreferrer" className="product-name">
        {item.productName}
      </a>
    ),
    category: (item) => item.category,
    price: (item) => item.price,
    quantitySold: (item) => item.quantitySold,
    total: (item) => item.total,
  });

  renderFilters() {
    const { filters, selectedItems, itemSearch, itemSuggestions, showSuggestions } = this.state;
    const stores = this.props.stores || [];

    return (
      <ReportFilters
        filters={filters}
        stores={stores}
        selectedItems={selectedItems}
        itemSearch={itemSearch}
        itemSuggestions={itemSuggestions}
        showSuggestions={showSuggestions}
        itemLabel="Products"
        itemPlaceholder="Search products..."
        onFilterChange={this.handleFilterChange}
        onItemSearchChange={this.handleItemSearchChange}
        onItemSelect={this.selectItem}
        onItemRemove={this.removeItem}
        onClearAllItems={this.clearAllItems}
        onFocus={() => itemSuggestions.length > 0 && this.setState({ showSuggestions: true })}
        onBlur={() => setTimeout(() => this.setState({ showSuggestions: false }), 200)}
      />
    );
  }

  render() {
    if (!this.props.dataFetched) return false;

    return (
      <div className="ItemsSoldReport">
        <Header text="Items Sold Report" actions={true}>
          <button
            className="button is-primary"
            onClick={this.handleDownload}
            disabled={this.state.downloading}
          >
            {this.state.downloading ? 'Downloading...' : 'Download CSV'}
          </button>
        </Header>

        {this.renderFilters()}

        <Table
          showHeader={true}
          headers={ITEM_HEADERS}
          formatters={this.itemFormatters()}
          rows={this.props.pageData || []}
          empty="No items found for the selected filters"
        />

        {this.props.grandTotal && (
          <div className="total-row">
            <strong>Total: {this.props.grandTotal}</strong>
          </div>
        )}

        <Paginate changePage={this.changePage} {...this.props.pagy} />
      </div>
    );
  }
}

const ITEM_HEADERS = {
  storeName: "Store",
  productName: "Product",
  category: "Category",
  price: "Price",
  quantitySold: "Qty Sold",
  total: "Total",
};

export default usesFeatures(["data", "pagination"], ItemsSoldReport);
